export default "__VITE_ASSET__b5f0b4a2__"